module.exports = __webpack_public_path__ + "media/img/institutions/default_logo-d8d34edbb6e8d8b3736f87068aad38c0.png";